module.exports = __webpack_public_path__ + "img/labmem_text_btntest_kr.f4f3728b.png";